import React, { Component } from 'react'
import SmoothCollapse from 'react-smooth-collapse'
import ProfilePicture from 'components/profile/profile-picture'
import Icon from 'components/icon/icon'

import { paragraphToLines } from 'utils/text'

import { 
	doClickEventListeners,
	doSort,
	i18nCopy
} from 'utils'

class DropdownMenu extends Component {
	ref = null
	searchRef = null
	canAddNewAndUnique = false // we're setting this in render, so it can't update state
	selectedItem = null
	menuItems = []
	menuItemRefs = {}

	state = {
		isOpened: false,
		activeTab: 0,
		searchTerm: '',
		activeItemIndex: 0
	}

	componentWillMount(){
		doClickEventListeners(this.handleClick)

		window.addEventListener('keydown', this.handleKeyPress)
	}

	componentWillUnmount(){
		doClickEventListeners(this.handleClick,true)

		window.removeEventListener('keydown', this.handleKeyPress)
	}

	componentDidUpdate = (prevProps, prevState) => {
		if(!prevState.isOpened && this.state.isOpened && this.searchRef){
			this.searchRef.focus()
		}

		if(prevProps.selectableItems && prevProps.selectableItems.length !== this.props.selectableItems.length){
			this.setState({
				activeItemIndex: 0
			})
		}
	}

	handleClick = e => {
		if(this.ref && !this.ref.contains(e.target)){
			this.forceCloseMenu()
		}
	}

	toggleMenu = _ => {
		this.setState({
			isOpened: !this.state.isOpened
		})
	}

	forceCloseMenu = _ => {
		this.setState({
			isOpened: false
		})
	}

	swapTab = activeTab => {
		this.setState({
			activeTab
		})
	}

	getName = (item, allowMarkup = false) => {
		const {
			parentType,
			valueKey
		} = this.props

		switch(this.props.parentType){
			case 'note':
				let allLines = paragraphToLines(item.text)
				let firstLine = null
		
				allLines.forEach(line => {
					if(line){
						if(!firstLine){
							firstLine = line
						}
					}
				})

				return firstLine ? firstLine : 'New note'
			case 'organisation':
				return (
					<span>
						{ (item.image_thumb_url || item.image_url || item.image_tiny_thumb_url) ?
							<ProfilePicture account={item} />
						: null }
						{ item.name }
					</span>
				)
			case 'organiser':
			case 'people':
			case 'stakeholder':
			case 'user':
				if(valueKey){
					if(valueKey === 'person_and_organisation_name'){
						if(item.first_name && item.last_name){
							return `${item.first_name} ${item.last_name} (${item.organisation_name})`
						}else if(item.organisation_name){
							return item.organisation_name
						}
					}else if(item[valueKey]){
						return item[valueKey]
					}
				}

				if(!item){
					return ''
				}

				if(item.name){
					return item.name
				}else{
					if(allowMarkup){
						return (
							<span>
								<ProfilePicture user={item} />
								{ item.first_name+' '+item.last_name }
							</span>
						)
						}else{
							return item.first_name+' '+item.last_name
						}
				}
			default:
				return item.name ? item.name : '(Deleted '+this.props.parentType+')'
		}
	}

	handleSearchChange = e => {
		const { handleSearchTermChange } = this.props

		const { value } = e.target

		this.setState({
			searchTerm: value
		})

		if(handleSearchTermChange){
			handleSearchTermChange(value)
		}
	}

	handleKeyPress = e => {
		const {
			activeItemIndex,
			activeTab
		} = this.state

		const {
			selectableItems,
			handleChange,
			parentKey,
			addNewCallback
		} = this.props

		if(this.isOpen()){
			const selectableItemsLength = selectableItems ? selectableItems.length : 0
			const itemsLength = this.canAddNewAndUnique ? (selectableItemsLength + 1) : selectableItemsLength

			if(e.key === 'ArrowDown'){
				if(activeItemIndex < (itemsLength - 1)){
					this.setState({
						activeItemIndex: (activeItemIndex + 1)
					})
				}
			}else if(e.key === 'ArrowUp'){
				if(activeItemIndex > 0){
					this.setState({
						activeItemIndex: (activeItemIndex - 1)
					})
				}
			}else if(e.key === 'Enter'){
				if(this.canAddNewAndUnique && !activeItemIndex){
					addNewCallback()
				}else{
					const selectedItem = this.menuItems[this.canAddNewAndUnique ? (activeItemIndex - 1) : activeItemIndex]

					if(selectedItem){
						handleChange(selectedItem.id, parentKey, activeTab)
					}
				}

				this.toggleMenu()
			}else if(e.key.length === 1){
				const nearestMenuItem = this.menuItems.find(item => {
					const nameString = item.name ? item.name : item.first_name

					if(nameString.toLowerCase().startsWith(e.key)){
						return true
					}
				})

				if(this.menuRef && nearestMenuItem && nearestMenuItem.id && this.menuItemRefs[nearestMenuItem.id]){
					this.menuRef.scrollTop = this.menuItemRefs[nearestMenuItem.id].offsetTop
				}
			}
		}
	}

	isOpen = _ => {
		return (this.state.isOpened || this.props.isForcedOpen)
	}

	getMenuItems = _ => {
		const {
			allItemEntities,
			selectedItemId,
			selectableItems,
			allowNone,
			parentType,
			isObjects,
			selectablePeople,
			selectableTeams,
			selectedItemType
		} = this.props

		const {
			activeTab
		} = this.state

		let menuItems = []

		if(!isObjects){
			this.selectedItem = (allItemEntities && allItemEntities[selectedItemId]) ? allItemEntities[selectedItemId] : null

			selectableItems.forEach(itemId => {
				let itemObject = allItemEntities[itemId]

				if(itemObject && this.getName(itemObject)){
					menuItems.push(itemObject)
				}
			})

			menuItems.sort((a,b) => {
				const aName = this.getName(a)
				const bName = this.getName(b)

				if(aName.toLowerCase() < bName.toLowerCase()) return -1
				if(aName.toLowerCase() > bName.toLowerCase()) return 1
				return 0
			})

			if(allowNone){
				menuItems.unshift({
					id: null,
					name: `(No ${parentType})`
				})
			}
		}else{
			if(parentType !== 'people' && parentType !== 'organiser'){
				this.selectedItem = selectableItems.find(item => {
					return item && item.id == selectedItemId
				})

				menuItems = selectableItems
			}else{
				if(parentType !== 'organiser'){
					menuItems = activeTab === 0 ? selectablePeople : selectableTeams

					if(selectedItemId){
						this.selectedItem = selectedItemType == 'person' ? selectablePeople.find(person => {
							return person && person.id === selectedItemId
						}) : selectableTeams.find(team => {
							return team && team.id === selectedItemId
						})
					}
				}else{
					menuItems = selectableItems

					if(selectedItemId){
						this.selectedItem = selectableItems.find(item => {
							return item && item.id === selectedItemId
						})
					}
				}

				menuItems = doSort(menuItems, 'alpha', activeTab == 0 ? 'first_name' : 'name')
			}
		}

		this.menuItems = menuItems
	}

	handleMouseEnter = index => {
		this.setState({
			activeItemIndex: index
		})
	}

	render(){
		const { 
			parentType, 
			selectedItemId, 
			label,
			parentKey,
			handleChange,
			canCreateNew,
			handleCreateNew,
			hasSearch,
			canAddNew,
			newItemValue,
			addNewCallback,
			hasAll,
			emptyLabel
		} = this.props 

		const {
			activeTab,
			searchTerm,
			activeItemIndex
		} = this.state

		const isOpenedOrForcedOpen = this.isOpen()

		this.getMenuItems()

		let emptyString

		switch(parentType){
			case 'people':
				emptyString = 'All people'
				break
			case 'category':
				emptyString = 'No categories'
				break
			case 'task':
				emptyString = 'Select task...'
				break
			default:
				if(emptyLabel){
					emptyString = emptyLabel
				}else if(!hasAll){
					emptyString = `No ${parentType}s`
				}else{
					emptyString = `All ${parentType}s`
				}
				break
		}

		let inputClassName = 'input'

		if(isOpenedOrForcedOpen){
			inputClassName += ' open'
		}

		this.canAddNewAndUnique = canAddNew

		if(canAddNew){
			let isUnique = true

			this.menuItems.forEach(menuItem => {
				if(menuItem.name == newItemValue){
					isUnique = false
				}
			})

			if(!isUnique || !newItemValue){
				this.canAddNewAndUnique = false
			}
		}

		return (
			<div 
				ref={e => this.ref = e} 
				className="folder-selector-dropdown"
			>
				<div>
					{
						label ?
						<label>
							{ label }:
						</label>
						: null
					}
					<span className={inputClassName} onClick={this.toggleMenu}>
						{
							(this.selectedItem && this.selectedItem.id) ?
							this.getName(this.selectedItem, true)
							:
							emptyString
						}
					</span>
					<div onClick={e => {e.stopPropagation()}}>
						<SmoothCollapse 
						 	heightTransition="0.1s ease"
							expanded={!!isOpenedOrForcedOpen}
						>
							{ hasSearch &&
								<div className="dropdown-menu-search">
									<input 
										type="text" 
										value={searchTerm}
										onChange={this.handleSearchChange}
										ref={ref => this.searchRef = ref}
										placeholder={`Search ${parentType}s...`}
									/>
									<Icon name="fe-search" />
								</div>
							}
							{ (parentType == 'people' && this.props.selectableTeams) ?
								<div className="tab-switch">
									{ ['People','Teams'].map((tab, index) => {
										return (
											<button
												onClick={_ => this.swapTab(index)}
												className={activeTab == index ? 'active' : null}
												key={index}
											>
												{ tab }
											</button>
										)
									}) }
								</div>
								: null
							}
							<ul ref={ref => this.menuRef = ref}>
								{ this.canAddNewAndUnique ?
									<li>
										<label
											onClick={addNewCallback}
											className={!activeItemIndex ? 'active' : null}
										>
											<span>
												Add "{ newItemValue }"
											</span>
										</label>
									</li>
								: null }
								{ hasAll ?
									<li>
										<label
											onClick={_ => {
												handleChange(-1, parentKey, activeTab)
												this.toggleMenu()
											}}
										>
											<span>
												All { parentType+'s' }
											</span>
										</label>
									</li>
								: null }
								{
									this.menuItems.map((item, index) => {
										if(!item){
											return null
										}
										
										const itemName = this.getName(item)
										const isActive = this.canAddNewAndUnique ? (activeItemIndex - 1) === index : activeItemIndex === index

										if(typeof itemName == 'string' && !itemName.toLowerCase().includes(searchTerm.toLowerCase())){
											return null
										}

										let className = isActive ? 'active' : ''

										if(selectedItemId === item.id){
											className += ' selected'
										}

										const menuItem = this.menuItems[index]

										return (
											<li 
												key={index}
												ref={ref => {
													if(menuItem.id){
														this.menuItemRefs[menuItem.id] = ref
													}
												}}
											>
												<label 
													onClick={_ => {
														handleChange(item.id, parentKey, activeTab)
														this.toggleMenu()}
													} 
													className={className}
													onMouseEnter={_ => {this.handleMouseEnter(index)}}
												>
													<span>
														{ this.getName(item, true) }
													</span>
												</label>
											</li>
										)
									})
								}
								{ canCreateNew &&
									<li>
										<label
											onClick={_ => {
												handleCreateNew()

												setTimeout(_ => {
													this.toggleMenu()
												})
											}}
										>
											<span>
												Create a new { i18nCopy(parentType) }...
											</span>
										</label>
									</li>
								}
							</ul>
						</SmoothCollapse>
					</div>
				</div>
			</div>
		);
	}

}

export default DropdownMenu


// WEBPACK FOOTER //
// ./src/components/dropdown-menu/dropdown-menu.jsx